import React, { useEffect, useState } from 'react';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import { Grid, TextField, Button, Box, Typography, Chip, alpha, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import request from '../../../services/Request';
import moment from 'moment';
import HistoryIcon from '@mui/icons-material/History';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';

export default function UserActivityLog(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  var date = new Date();
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reflesh, setReflesh] = useState(false);
  const [sw, setsw] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const [data, setData] = useState([]);

  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());

  const columns = [
    {
      title: 'Timestamp',
      field: 'timestamp',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccessTimeIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
            {new Date(rowData.timestamp).toLocaleString()}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Details',
      field: 'details',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DescriptionIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {rowData.details}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Name',
      field: 'user',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PersonIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
            {`${rowData.user.firstname} ${rowData.user.lastname}`}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Email',
      field: 'user.email',
      render: (rowData) => (
        <Chip
          icon={<EmailIcon sx={{ fontSize: 16 }} />}
          label={rowData.user.email}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    let isCancelled = false;
    setLoading(false);
    //getAllEmployees
    async function getAllAdmins() {
      await request({
        method: 'get',
        url: `/users/getAllEmployees`,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('res.data', res.data);
          if (res.data.length > 0) {
            let array = [{ email: 'All', groupname: 'All User' }, ...res.data];
            setGroups(array);
            setLoading(true);
          }
        }
      });
    }

    getAllAdmins();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleChange = async () => {
    setLoading(false);
    // console.log(groupV);
    request({
      method: 'post',
      url: '/userLogs/getAdminActivityLog',
      data: {
        // group: groupV,
        startDate: startDate,
        endDate: endDate,
        email: groupV.email,
      },
    })
      .then((res) => {
        console.log('ALL logs', res.data);
        setOriginalData(res.data);
        //filterData if user.email includes @dba
        setData(res.data.filter((e) => !e.user?.email.includes('@dba.com')));
      })
      .catch(() => {})
      .finally(() => {
        setLoading(true);
        setReflesh(!reflesh);
      });
  };

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title="User Activity Log"
        subtitle="Track user actions and activities in the system"
        icon={HistoryIcon}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid xs={4} item container justifyContent="flex-start">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={startDate}
                onChange={(e) => handleStartDate(e)}
                label="Select start date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    margin: 'normal',
                    id: 'date-picker-start',
                    sx: { mr: 1 },
                  },
                }}
              />
              <DatePicker
                value={endDate}
                onChange={(e) => handleEndDate(e)}
                label="Select end date"
                format="MM/dd/yyyy"
                slotProps={{
                  textField: {
                    margin: 'normal',
                    id: 'date-picker-end',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={4} item container justifyContent="flex-start" alignContent="center" alignItems="center">
            <Autocomplete
              value={groupV}
              options={groups}
              onChange={(event, value) => {
                setgroupV(value);
              }}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => (option?.groupname ? option?.groupname : '')}
              fullWidth
              renderInput={(params) => <TextField {...params} variant="outlined" label="Customers" />}
            />
          </Grid>
          <Grid item xs={1} sx={{ ml: 2 }}>
            {!props.compare && (
              <Button
                sx={{ height: '40px' }}
                onClick={handleChange}
                disabled={!groupV?.email || !loading}
                variant="contained"
                color="primary"
              >
                Submit
              </Button>
            )}
          </Grid>
          <Grid item xs={1} sx={{ ml: 2 }}>
            <Button
              sx={{ height: '40px', width: '150px' }}
              onClick={() => {
                setsw(!sw);
              }}
              variant="contained"
              color="primary"
            >
              {sw ? 'Hide DBA' : 'Show DBA'}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          columns={columns}
          data={sw ? originalData : data}
          options={{
            actionsColumnIndex: -1,
            pageSize: 100,
            pageSizeOptions: [100, 200, 500, 1000, 2000],
          }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>
    </ModernPageContainer>
  );
}
